/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

import { BlockType } from "@vienna/common";

import { DEVICE } from "src/app/globalStyles";
import { Block } from "src/classes/block";
import { StyleConstants } from "src/classes/utilities/StyleConstants";
import { SBlockContent } from "src/components/Block/BlockContent/SBlockContent";

interface Props {
  block: Block;
}

export function BigBlock({ block }: Props) {
  return (
    <StyledBigBlock
      id="cy-big-block"
      style={StyleConstants.getDrilledViewStyles(block)}
      isImageBlock={block.snapshot.type === BlockType.Image}
      // @todo why is this here?
      onClick={(e: React.MouseEvent) => block.snapshot.type !== BlockType.Image && e.stopPropagation()}
    >
      <SBlockContent block={block} />
    </StyledBigBlock>
  );
}

interface StyledBlockProps {
  isImageBlock?: boolean;
  isPageWindow?: boolean;
}

export const StyledBigBlock = styled.div<StyledBlockProps>`
  position: relative;
  background-color: ${({ isImageBlock, theme, isPageWindow }) =>
    !isImageBlock && !isPageWindow ? theme.background : "transparent"};
  border: ${({ theme, isImageBlock, isPageWindow }) =>
    !isImageBlock && !isPageWindow && `1px solid ${theme.block.border}`};
  flex-shrink: 1;
  object-fit: contain; // tells images to get as big as they can without changing their aspect ratio
  display: flex;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  @media (max-width: ${DEVICE.small}) {
    width: 100%;
    min-height: 75%;
    padding: 0;
    margin-top: 50px;
    margin-bottom: 50px;
  }
`;
